var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCauzeLogotype = function SvgCauzeLogotype(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "154px",
    height: "30px",
    viewBox: "0 0 154 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cauze-logotype-accent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cauze-logotype-accent",
    transform: "translate(0.000000, -2.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,8 L48,5 L56,5 L56,31 L48,31 L48,28 C45.648,30.688 42.908,32 39.212,32 C31.82,32 26.5,25.952 26.5,18 C26.5,9.712 32.156,4 39.94,4 C43.244,4 45.48,5.256 48,8 Z M41.788,11.056 C38.148,11.056 35.572,14.024 35.572,18.168 C35.572,22.144 38.26,25.224 41.732,25.224 C45.26,25.224 48.116,21.976 48.116,18.056 C48.116,13.912 45.484,11.056 41.788,11.056 Z",
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "z",
    points: "110.440389 23.924406 120 5 98 5 98 12.075594 106.958747 12.075594 97 31 119.5 31 119.5 23.924406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.437047,23.113875 L152.826295,24.5931257 C151.828428,26.5129058 150.422672,27.8707492 149.094488,28.9138277 C146.503937,30.98998 143.307087,32 140,32 C131.677165,32 126,26.248497 126,18 C126,9.75150301 131.732283,4 140,4 C148.433071,4 154,9.89178357 154,18.757515 C154,19.3172186 153.961768,20.0647135 153.885303,21 L134.653543,21 C134.8125,23.5589844 137.588884,24.8708158 140,24.875 C141.785276,24.8780981 143.356797,24.1774341 144.437047,23.113875 Z M134.598425,15.8 L145.456693,15.8 C144.978085,13.1714668 143.256836,11.0701403 139.944882,11.0701403 C136.766016,11.0701403 135.079553,13.1576281 134.598425,15.8 Z",
    id: "e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,23.5 L76.5,23.5 C73.1862915,23.5 70.5,20.8137085 70.5,17.5 C70.5,14.1862915 73.1862915,11.5 76.5,11.5 L78.5,11.5 L78.5,3.5 L76.5,3.5 C68.7680135,3.5 62.5,9.7680135 62.5,17.5 C62.5,25.2319865 68.7680135,31.5 76.5,31.5 L78.5,31.5 L78.5,23.5 Z M87.5,28.5 C85.290861,28.5 83.5,26.709139 83.5,24.5 C83.5,22.290861 85.290861,20.5 87.5,20.5 C89.709139,20.5 91.5,22.290861 91.5,24.5 C91.5,26.709139 89.709139,28.5 87.5,28.5 Z M87.5,14.5 C85.290861,14.5 83.5,12.709139 83.5,10.5 C83.5,8.290861 85.290861,6.5 87.5,6.5 C89.709139,6.5 91.5,8.290861 91.5,10.5 C91.5,12.709139 89.709139,14.5 87.5,14.5 Z",
    id: "Combined-Shape",
    transform: "translate(77.000000, 17.500000) rotate(-80.000000) translate(-77.000000, -17.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,24 L14,24 C10.6862915,24 8,21.3137085 8,18 C8,14.6862915 10.6862915,12 14,12 L20,12 L20,4 L14,4 C6.2680135,4 0,10.2680135 0,18 C0,25.7319865 6.2680135,32 14,32 L20,32 L20,24 Z",
    id: "Combined-Shape"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCauzeLogotype);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cauze-logotype.00edda20c0a26ae17805bf2ed1c28463.svg";